import React from 'react'

import { WalletType } from '~/lib/useWallet'

import ontoLogo from '~/assets/wallets/onto-logo.png'
import imTokenLogo from '~/assets/wallets/im-token-logo.png'
import bitKeepLogo from '~/assets/wallets/bitkeep.png'
import metamaskLogo from '~/assets/wallets/metamask-logo.png'
import trustLogo from '~/assets/wallets/trust-logo.png'
import coin98Logo from '~/assets/wallets/coin98-logo.png'
import xdefiLogo from '~/assets/wallets/xdefi-logo.png'
import walletConnectLogo from '~/assets/wallets/wallet-connect-logo.png'
import blockchainComLogo from '~/assets/wallets/blockchain-com-logo.png'
import operaLogo from '~/assets/wallets/opera-logo.png'
import safePalLogo from '~/assets/wallets/safe-pal-logo.png'
import kuCoinLogo from '~/assets/wallets/ku-coin-logo.png'

import css from './WalletLink.pcss'

interface Props {
	walletType: WalletType
	onClick: (
		event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
		wallet: WalletType
	) => void
}

export function WalletLink({ walletType, ...props }: Props) {
	let icon
	let href = ''
	let title = ''

	if (walletType === WalletType.METAMASK) {
		icon = metamaskLogo
		href = `https://metamask.app.link/dapp/${window.location.href}`
		title = 'Metamask'
	} else if (walletType === WalletType.XDEFI) {
		icon = xdefiLogo
		href = 'https://www.xdefi.io'
		title = 'XDEFI'
	} else if (walletType === WalletType.COIN98) {
		icon = coin98Logo
		href = 'https://coin98.com'
		title = 'Coin98'
	} else if (walletType === WalletType.WALLET_CONNECT) {
		icon = walletConnectLogo
		title = 'Wallet Connect'
	} else if (walletType === WalletType.TRUST) {
		icon = trustLogo
		href = 'https://trustwallet.com'
		title = 'Trust Wallet'
	} else if (walletType === WalletType.ONTO) {
		icon = ontoLogo
		href = 'https://onto.app'
		title = 'ONTO Wallet'
	} else if (walletType === WalletType.IM_TOKEN) {
		icon = imTokenLogo
		href = 'https://token.im'
		title = 'imToken'
	} else if (walletType === WalletType.BITKEEP) {
		icon = bitKeepLogo
		href = 'https://bitkeep.com/download?type=2'
		title = 'BitKeep'
	} else if (walletType === WalletType.BLOCKCHAIN_COM) {
		icon = blockchainComLogo
		href = 'http://blockchain.com'
		title = 'Blockchain.com'
	} else if (walletType === WalletType.OPERA) {
		icon = operaLogo
		href = 'https://www.opera.com'
		title = 'Opera Wallet'
	} else if (walletType === WalletType.SAFE_PAL) {
		icon = safePalLogo
		href = 'https://safepal.io'
		title = 'SafePal'
	} else if (walletType === WalletType.KUCOIN) {
		icon = kuCoinLogo
		href = 'https://kuwallet.com'
		title = 'KuCoin Wallet'
	}

	function onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
		props.onClick(event, walletType)
	}

	return (
		<a
			className={css.container}
			href={href}
			rel="noopener noreferrer"
			target="_blank"
			onClick={onClick}
		>
			<img className={css.icon} src={icon} alt={title} />
			<span>{title}</span>
		</a>
	)
}
